import Vue from 'vue'
import Vuetify from 'vuetify'
import fr from 'vuetify/es5/locale/fr';
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

import '../style/main.css'

Vue.use(Vuetify)
const opts = {
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#6f3cfb',
                secondary: '#00fe8e',
                blue: '#3b8aff',
                red: '#ee6858',
                error: '#ee6858',
                success: '#38cb89',
                orange: '#ffab00',
            }
        },
    },
    lang: {
        locales: {fr},
        current: 'fr',
    },
    icons: {
        iconfont: 'mdi',
    },
}
export default new Vuetify(opts)
